import { css, SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'
import { FC } from 'react'

const StyledAnchor = styled('a')`
    display: inline-block;
    width: 50px;
    height: 50px;
    position: relative;
    overflow: hidden;
    vertical-align: middle;
`

const StyledIcon = styled('div')`
    border-radius: 50%;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    fill-rule: evenodd;
`

/**
 * Current social platforms supported
 */
export enum SocialPlatforms {
    instagram = 'instagram',
    twitter = 'twitter',
}

interface ISocialIcon {
    dimension?: number
    platform: SocialPlatforms
    url: string
}

function getSocialIcon(
    platform: SocialPlatforms,
): SerializedStyles | undefined {
    switch (platform) {
        case SocialPlatforms.instagram:
            return css`
                background-image: url(/static/icons/instagram.svg);
                background-position: left;
                background-size: auto;
                background-repeat: no-repeat;
            `
        case SocialPlatforms.twitter:
            return css`
                background-image: url(/static/icons/x-social-logo.svg);
                background-position: left;
                background-size: auto;
                background-repeat: no-repeat;
            `
        default:
            return
    }
}

export const SocialIcon: FC<ISocialIcon> = ({ dimension, platform, url }) => {
    const socialIcon = getSocialIcon(platform)
    const testId = `SocialIcon__${platform}`
    const customDimensions = dimension
        ? css({ height: dimension, width: dimension })
        : null
    return (
        <StyledAnchor
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            css={customDimensions}
            data-testid={testId}
        >
            <StyledIcon css={socialIcon} />
        </StyledAnchor>
    )
}
